import { CalendarPlus, Menu } from 'lucide-react';
import { Link } from 'react-router';

import { NotificationTray } from '@/components/NotificationTray';
import { Button } from '@/components/ui/button';

/**
 * The client portal's topbar.
 *
 * **The "Request a Cleaning" call to action is persistent, on every page.** That
 * is the prototype's decision and it is the right one: asking for a clean is the
 * one thing a customer opens this to do, and burying it one level down in the
 * nav turns it back into a phone call (FINDINGS.md §10.5).
 *
 * No search box, unlike the admin topbar — a customer with four cleans a year
 * has nothing to search. The bell is phase 11.1's shared tray.
 */
export function ClientTopbar({ onOpenMenu }: { onOpenMenu: () => void }) {
  return (
    <header className="sticky top-0 z-20 flex items-center gap-2 border-b border-ink-300 bg-white px-3 py-2 sm:px-4">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        aria-label="Open menu"
        onClick={onOpenMenu}
      >
        <Menu aria-hidden="true" />
      </Button>

      {/* 44px floor, same as the employee topbar's — this was 99×22 and the
          phase-6 touch-target sweep is what measured it. */}
      <Link
        to="/portal"
        className="inline-flex min-h-touch items-center text-h3 text-bark-700 lg:hidden"
      >
        Honeycomb
      </Link>

      <div className="flex-1" />

      <NotificationTray basePath="/api/client" />

      <Button asChild>
        <Link to="/portal/request">
          <CalendarPlus aria-hidden="true" />
          {/* The full label from the small screen up; "Request" alone below it,
              so the button never wraps or clips on a phone. */}
          <span className="hidden sm:inline">Request a Cleaning</span>
          <span className="sm:hidden">Request</span>
        </Link>
      </Button>
    </header>
  );
}
